import * as React from 'react'
import PropTypes from 'prop-types'

export default function StickyElement({ children }) {
  const containerRef = React.useRef(null)
  const [containerSize, setContainerSize] = React.useState(null)
  const [isSticked, setSticked] = React.useState(false)

  React.useEffect(() => {
    if (containerRef.current) {
      const bounding = containerRef.current.getBoundingClientRect()

      setContainerSize(bounding)

      const cb = () => {
        window.requestAnimationFrame(() => {
          if (window.scrollY >= bounding.y / 2) {
            setSticked(true)
          } else {
            setSticked(false)
          }
        })
      }
      // eslint-disable-next-line callback-return
      cb()

      window.addEventListener('scroll', cb)

      return () => {
        window.removeEventListener('scroll', cb)
      }
    }
    // eslint-disable-next-line react/display-name
    return () => null
  }, [containerRef])

  return (
    <div
      className={`sticky-element-container${isSticked ? ' sticked' : ''}`}
      style={
        containerSize
          ? { height: containerSize.height, width: containerSize.width }
          : {}
      }
      ref={containerRef}
    >
      {React.cloneElement(children, { isSticked })}
    </div>
  )
}

StickyElement.propTypes = {
  children: PropTypes.elementType.isRequired,
}
